/* eslint-disable-next-line import/no-cycle */
import auctionMessageHandlers from './messageHandlers';

const generateEndedUpdateMessage = (message) => {
  if (message.status === 'negotiation' || message.status === 'counter_sent') {
    // console.warn('converting an old push msg to new format');
    return {
      type: 'ENDED_UPDATE',
      data: {
        auction: {
          status: message.auction_status ? message.auction_status : message.status,
          id: parseInt(message.auction_id, 10),
        },
      },
    };
  }

  return message;
};

function getData(message) {
  if (!message.data) {
    if (message.pn_fcm) return message.pn_fcm.data;
  }
  if (message.pn_apns?.aps) return message.pn_apns.aps;
  if (message.auction) return { auction: message.auction };
  if (message.data) return message.data;
  return message;
}
const handleMessage = (store) => {
  /* eslint-disable no-unused-vars */
  store.subscribeAction((action, state) => {
    if (action.type !== 'handleMessage' || !state.messaging.handleMessages) return;
    let { message } = action.payload.message;

    if (!message.channel_key && message.status) {
      message = generateEndedUpdateMessage(message);
    }

    const data = getData(message);

    let type = message.type || data.type;

    if (!type) return;
    type = type.toUpperCase();
    if (type === 'OUT_BID') data.auction = message.auction;
    else {
      data.success = message.success;
    }

    if (Object.keys(auctionMessageHandlers).includes(type)) {
      auctionMessageHandlers[type](store, data);
    }
  });
};

export default handleMessage;
